import React, { ReactElement } from "react"

import styles from "./Divider.module.scss"

const Divider = (): ReactElement => <div className={styles.divider}></div>

export default Divider
